var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2972",
    "data-name": "Group 2972",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.366,
    height: 18,
    viewBox: "0 0 26.366 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3218",
    "data-name": "Rectangle 3218",
    width: 13.905,
    height: 2.553,
    transform: "translate(0.001)",
    fill: "#19162f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3219",
    "data-name": "Rectangle 3219",
    width: 9.906,
    height: 2.553,
    transform: "translate(16.46)",
    fill: "#ff331f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3220",
    "data-name": "Rectangle 3220",
    width: 10.095,
    height: 2.553,
    transform: "translate(0 7.723)",
    fill: "#ff331f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3221",
    "data-name": "Rectangle 3221",
    width: 13.718,
    height: 2.553,
    transform: "translate(12.648 7.723)",
    fill: "#19162f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3222",
    "data-name": "Rectangle 3222",
    width: 7.815,
    height: 2.553,
    transform: "translate(0 15.447)",
    fill: "#19162f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3223",
    "data-name": "Rectangle 3223",
    width: 6.095,
    height: 2.553,
    transform: "translate(20.271 15.447)",
    fill: "#19162f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3224",
    "data-name": "Rectangle 3224",
    width: 7.35,
    height: 2.553,
    transform: "translate(10.368 15.447)",
    fill: "#ff331f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyword);
export default __webpack_public_path__ + "static/media/keyword.7c3560b4a221252283ab7dc7f842c7e6.svg";
export { ForwardRef as ReactComponent };